import { baseApi } from '../../../shared/api/baseApi';
import type { ServiceMessageStatusDto } from '../model/dto';

const ENDPOINT = '/api/admin/tech_supports/technical_support';

const TAG = 'ServiceMessage' as const;

export const serviceMessageApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        /** Показывается ли пользователям баннер о регламентных работах. */
        getServiceMessageStatus: build.query<boolean, void>({
            query: () => `${ENDPOINT}/get_status_problem`,
            transformResponse: (response: ServiceMessageStatusDto) => response?.status === true,
            providesTags: [{ type: TAG, id: 'STATUS' }],
        }),

        toggleServiceMessage: build.mutation<boolean, boolean>({
            query: (status) => ({
                url: `${ENDPOINT}/set_status_problem`,
                method: 'POST',
                body: { status },
            }),
            transformResponse: (response: ServiceMessageStatusDto) => response?.status === true,
            invalidatesTags: [{ type: TAG, id: 'STATUS' }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetServiceMessageStatusQuery, useToggleServiceMessageMutation } = serviceMessageApi;